import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginAwareComponent } from '../login-aware-component';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * This component is shown only to logged in users, and statically displays 'Campfire' heading.
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService) {
    super(diagnosticsFactory.create('HeaderComponent'), broadcastService, authService);
  }
}
